<template>
  <div>
    <p v-html="$t('companies-contact-form.form.success')"></p>
  </div>
</template>

<script>
import es from '@/lang/es/forms/companies-contact-form.json'
import en from '@/lang/en/forms/companies-contact-form.json'
import pt from '@/lang/pt/forms/companies-contact-form.json'
export default {
  i18n: {
    messages: {
      es,
      en,
      mx: es,
      pt
    }
  },
  mounted () {
    // Reload page only once by session storage
    if (sessionStorage.getItem('reloaded') === null) {
      sessionStorage.setItem('reloaded', 'true')
      window.location.reload()
    } else {
      sessionStorage.removeItem('reloaded')
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/views/CompaniesContactFormSuccess.vue